import { render, staticRenderFns } from "./PersistResponsavelVisualizadorView.vue?vue&type=template&id=43088515&"
import script from "./PersistResponsavelVisualizadorView.vue?vue&type=script&lang=ts&"
export * from "./PersistResponsavelVisualizadorView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports